<!-- gradelist/index.vue -->
<template>
  <div class="grade-list">

    <div class="grade-list-hd">
      <div class="grade-list-hd-left">
        <span class="grade-list-title">学历列表</span>
        <span v-if="gradelist && gradelist.length" class="grade-count">{{ gradelist.length }} 条</span>
      </div>
      <el-button v-if="editable" size="mini" class="btn btn--blue" @click="dialogvisible = true">
        <i class="el-icon-plus" /> 添加学历
      </el-button>
    </div>

    <div v-if="!gradelist || !gradelist.length" class="grade-empty">
      <i class="el-icon-school grade-empty-icon" />
      <div class="grade-empty-text">暂无学历信息</div>
      <el-button v-if="editable" size="mini" class="btn btn--blue" style="margin-top:10px" @click="dialogvisible = true">
        <i class="el-icon-plus" /> 添加学历
      </el-button>
    </div>

    <div v-else class="grade-items">
      <div v-for="(row, index) in gradelist" :key="index" class="grade-item">

        <!-- 左：学校+专业 -->
        <div class="grade-item-left">
          <div class="grade-school">{{ row.SchoolName }}</div>
          <div class="grade-major">{{ row.Major || '未录入专业' }}</div>
        </div>

        <!-- 中：学历+学年制 -->
        <div class="grade-item-mid">
          <span class="level-badge" :class="levelClass(row.Level)">{{ row.Level || '-' }}</span>
          <span v-if="row.TotalYear" class="o-tag tag-gray">{{ row.TotalYear }} 年制</span>
        </div>

        <!-- 中：时间段 -->
        <div class="grade-item-time">
          <div class="time-row">
            <span class="time-label">入学</span>
            <span class="time-val">{{ row.AdmissionDate ? new Date(row.AdmissionDate).toLocaleDateString('zh-CN', { year:'numeric', month:'2-digit' }) : '-' }}</span>
          </div>
          <div class="time-arrow">→</div>
          <div class="time-row">
            <span class="time-label">毕业</span>
            <span class="time-val">{{ graduationDate(row) || '-' }}</span>
          </div>
          <span v-if="statusTag(row)" class="o-tag" :class="statusTag(row).cls" style="margin-left:8px">{{ statusTag(row).text }}</span>
        </div>

        <!-- 右：移除 -->
        <div v-if="editable" class="grade-item-actions">
          <span class="grade-remove" @click="deleteRow(index)">
            <i class="el-icon-close" />
          </span>
        </div>

      </div>
    </div>

    <el-dialog
      title="添加学历信息"
      append-to-body
      destroy-on-close
      :visible.sync="dialogvisible"
      width="520px"
      @close="dialogvisible = false"
    >
      <grade-input @created="newgrade" @close="dialogvisible = false" :isstudent="isstudent" />
    </el-dialog>

  </div>
</template>

<script>
import GradeInput from '@/views/writer/components/gradelist/GradeInputForm'

export default {
  name: 'GradeList',
  components: { GradeInput },
  props: {
    gradelist: Array,
    editable:  { default: false },
    isstudent: { default: false }
  },
  data() {
    return { dialogvisible: false }
  },
  methods: {
    levelClass(level) {
      return { 'Undergraduate': 'level-ug', 'Master': 'level-ms', 'PHD': 'level-phd' }[level] || 'level-default'
    },
    graduationDate(row) {
      if (!row.AdmissionDate || !row.TotalYear) return null
      const d = new Date(row.AdmissionDate)
      d.setFullYear(d.getFullYear() + row.TotalYear)
      return d.toLocaleDateString('zh-CN', { year: 'numeric', month: '2-digit' })
    },
    statusTag(row) {
      if (!row.AdmissionDate || !row.TotalYear) return null
      const now = new Date()
      const start = new Date(row.AdmissionDate)
      const end = new Date(row.AdmissionDate)
      end.setFullYear(end.getFullYear() + row.TotalYear)
      if (now > end)         return { text: '已毕业', cls: 'tag-success' }
      if (now > start)       return { text: '在读中', cls: 'tag-info' }
      return                        { text: '未入读', cls: 'tag-warn' }
    },
    newgrade(grade) {
      grade.ID = -Number(new Date())
      this.gradelist.push(grade)
      this.dialogvisible = false
    },
    deleteRow(index) {
      this.gradelist.splice(index, 1)
    }
  }
}
</script>

<style scoped>
.grade-list {
  border: 0.5px solid rgba(0,0,0,0.08);
  border-radius: 10px;
  overflow: hidden;
  background: #fff;
}

/* 表头 */
.grade-list-hd {
  display: flex; align-items: center; justify-content: space-between;
  padding: 11px 14px;
  border-bottom: 0.5px solid rgba(0,0,0,0.06);
  background: #fafafa;
}
.grade-list-hd-left { display: flex; align-items: center; gap: 8px; }
.grade-list-title   { font-size: 13px; font-weight: 500; color: #1a1a1a; }
.grade-count {
  font-size: 11px; font-weight: 500;
  color: #0C447C; background: #E6F1FB;
  padding: 1px 7px; border-radius: 10px;
}

/* 空状态 */
.grade-empty {
  display: flex; flex-direction: column; align-items: center;
  padding: 32px 20px;
}
.grade-empty-icon { font-size: 28px; color: #ddd; margin-bottom: 8px; }
.grade-empty-text { font-size: 13px; color: #bbb; }

/* 学历行 */
.grade-items { padding: 0; }
.grade-item {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 12px 14px;
  border-bottom: 0.5px solid rgba(0,0,0,0.04);
  transition: background 0.12s;
}
.grade-item:last-child { border-bottom: none; }
.grade-item:hover      { background: #f9fbff; }

/* 左：学校专业 */
.grade-item-left { flex: 1; min-width: 0; }
.grade-school {
  font-size: 13px; font-weight: 500; color: #1a1a1a;
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
  margin-bottom: 3px;
}
.grade-major { font-size: 12px; color: #aaa; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }

/* 中：学历+学年 */
.grade-item-mid {
  display: flex; align-items: center; gap: 6px; flex-shrink: 0;
}

/* 学历徽标 */
.level-badge {
  display: inline-flex; align-items: center; justify-content: center;
  height: 22px; padding: 0 8px;
  border-radius: 5px; font-size: 11px; font-weight: 500;
}
.level-ug      { background: #E6F1FB; color: #0C447C; border: 0.5px solid #B5D4F4; }
.level-ms      { background: #EEEDFE; color: #3C3489; border: 0.5px solid #AFA9EC; }
.level-phd     { background: #FAEEDA; color: #633806; border: 0.5px solid #FAC775; }
.level-default { background: #f0f0f0; color: #888;    border: 0.5px solid #ddd; }

/* 中：时间段 */
.grade-item-time {
  display: flex; align-items: center; gap: 6px;
  flex-shrink: 0;
}
.time-row { display: flex; align-items: center; gap: 4px; }
.time-label {
  font-size: 11px; color: #aaa; font-weight: 500;
  background: #f5f5f5; padding: 1px 5px; border-radius: 3px;
}
.time-val { font-size: 12px; color: #444; font-variant-numeric: tabular-nums; }
.time-arrow { font-size: 12px; color: #ddd; }

/* 移除 */
.grade-item-actions { flex-shrink: 0; }
.grade-remove {
  display: inline-flex; align-items: center; justify-content: center;
  width: 24px; height: 24px; border-radius: 6px;
  cursor: pointer; color: #ccc; transition: color 0.12s, background 0.12s;
}
.grade-remove:hover { color: #E24B4A; background: #FCEBEB; }
.grade-remove i { font-size: 12px; }

/* 通用按钮 */
.btn {
  height: 26px !important; padding: 0 9px !important;
  border-radius: 6px !important; font-size: 12px !important;
  border: 0.5px solid rgba(0,0,0,0.1) !important;
  background: #fff !important; color: #555 !important;
  display: inline-flex !important; align-items: center !important; gap: 3px !important;
}
.btn:hover       { background: #f5f5f5 !important; }
.btn--blue       { background: #E6F1FB !important; border-color: #B5D4F4 !important; color: #0C447C !important; }
.btn--blue:hover { background: #cde4f7 !important; }

/* 通用 Tag */
.o-tag { display: inline-flex; align-items: center; height: 20px; padding: 0 7px; border-radius: 10px; font-size: 11px; font-weight: 500; white-space: nowrap; }
.tag-success { background: #EAF3DE; color: #27500A; }
.tag-info    { background: #E6F1FB; color: #0C447C; }
.tag-warn    { background: #FAEEDA; color: #633806; }
.tag-gray    { background: #f0f0f0; color: #888; }
</style>